/********************************************
 * Values Slider
 *
 * Flickity carousel
 * https://flickity.metafizzy.co/
 ********************************************/
function fnValuesSlider(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oCarousel = $('.carousel', oSection),
        oArrows	= $( '.nav-arrows', oSection ),
        oSlides = $('.slide', oSection);


    /*****************
     * Carousel configuration
     *****************/

    /**
     * Initialise Flickity
     */

    if (oSlides.length > 1) {
        var $oFlickity = oCarousel.flickity({
            isDraggable: false,
            wrapAround: true,
            cellAlign: 'center',
            accessibility: false,
            prevNextButtons: false,
            pageDots: false,
            adaptiveHeight: true,
            fade: true,
        });

        /**
         * Arrow buttons (prev/next)
         */
        oArrows.find( '.next' ).on( 'click', function() {
            $oFlickity.flickity( 'next' );
        });
        oArrows.find( '.previous' ).on( 'click', function() {
            $oFlickity.flickity( 'previous' );
        });
    }

}


// END OF DOCUMENT
